import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { CampaignFilters } from '@/api/routes/campaigns/types';
import smartSort from '@/utils/smartSort';

import { fetchCampaignsFilters, fetchStaticCampaignsFilters } from './actionCreators';
import { filters } from './mocks';

interface InitialState {
  filters: CampaignFilters,
  isLoading: boolean,
  error: string,
}

const initialState: InitialState = {
  filters,
  isLoading: false,
  error: '',
};

export const filtersSlice = createSlice({
  name: 'campaignFilters',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchCampaignsFilters.fulfilled.type]: (state, action: PayloadAction<CampaignFilters>) => {
      state.isLoading = false;
      state.error = '';
      state.filters = {
        org: action.payload.org.sort(smartSort),
        priority: action.payload.priority.sort(),
        tags: action.payload.tags.sort(smartSort),
        ad_video_type: action.payload.ad_video_type.sort(smartSort),
        ad_tags: action.payload.ad_tags.sort(smartSort),
      };
    },
    [fetchCampaignsFilters.pending.type]: (state) => {
      state.isLoading = true;
    },
    [fetchCampaignsFilters.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    [fetchStaticCampaignsFilters.fulfilled.type]: (state, action: PayloadAction<CampaignFilters>) => {
      state.isLoading = false;
      state.error = '';
      state.filters = {
        org: action.payload.org.sort(smartSort),
        priority: action.payload?.priority?.sort() || [],
        tags: action.payload?.tags?.sort(smartSort) || state?.filters?.tags?.sort(smartSort) || [],
        ad_video_type: action.payload?.ad_video_type?.sort(smartSort) || [],
        ad_tags: action.payload?.ad_tags?.sort(smartSort) || [],
      };
    },
    [fetchStaticCampaignsFilters.pending.type]: (state) => {
      state.isLoading = true;
    },
    [fetchStaticCampaignsFilters.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export default filtersSlice.reducer;
